import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Pencil = ({ color = '#838685', ...rest }: Props) => {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.83333 22.6667H7.49583L18.9 11.2625L17.2375 9.6L5.83333 21.0042V22.6667ZM3.5 25V20.0417L18.9 4.67083C19.1333 4.45694 19.391 4.29167 19.6729 4.175C19.9549 4.05833 20.2514 4 20.5625 4C20.8736 4 21.175 4.05833 21.4667 4.175C21.7583 4.29167 22.0111 4.46667 22.225 4.7L23.8292 6.33333C24.0625 6.54722 24.2326 6.8 24.3396 7.09167C24.4465 7.38333 24.5 7.675 24.5 7.96667C24.5 8.27778 24.4465 8.57431 24.3396 8.85625C24.2326 9.13819 24.0625 9.39583 23.8292 9.62917L8.45833 25H3.5ZM18.0542 10.4458L17.2375 9.6L18.9 11.2625L18.0542 10.4458Z"
        fill={color}
      />
    </Svg>
  )
}

export default Pencil
